import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入 swiper 插件
import  "swiper/swiper.min.css"

// px转rem（与 vue.config.js 中 postcss-px2rem 的 remUnit: 128 配套，按 1280 设计稿等比缩放）
// 注意：不要用 lib-flexible，它会把根字号封顶在 540px 视口，导致桌面端整体缩小为约 42%
import './config/rem'

import config from './config/index'
import http from './utils/http'

// 高德离线地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
    // 高德key
    key: '8eaa3fe7f90c50cadf192566109ea807',
    // 插件集合
    plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'AMap.CircleEditor'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
})

router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})

Vue.prototype.$A = config;
Vue.prototype.$H = http
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
